import { FC } from "react";
import { Box } from "@mui/material";
import { Avatar } from "@benefit-systems/hr-tools-ui";
import { TAutocompleteOption } from "./AutocompleteOption.models";

const AutocompleteOption: FC<TAutocompleteOption> = ({ props, option }) => (
  <li {...props} key={props.key}>
    <Box
      sx={(theme) => ({
        flexGrow: 1,
        "& span": {
          color: "#8b949e",
          ...theme.applyStyles("light", {
            color: "#586069",
            fontSize: "12px",
          }),
        },
      })}
    >
      {option?.name ? (
        option.name
      ) : (
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <Box sx={{ width: 36, height: 36, mr: "5px", ml: "-2px" }}>
            <Avatar size={8} src={option.avatar}>
              {option.initials}
            </Avatar>
          </Box>

          <Box
            sx={(theme) => ({
              flexGrow: 1,
              "& span": {
                color: "#8b949e",
                ...theme.applyStyles("light", {
                  color: "#586069",
                  fontSize: "12px",
                }),
              },
            })}
          >
            {option.label}
            <br />
            <span>{option.fk}</span>
            {option.position && (
              <>
                <br />
                <span>{option.position}</span>
              </>
            )}
          </Box>
        </Box>
      )}
    </Box>
  </li>
);

export default AutocompleteOption;
